import { forwardRef, useMemo } from 'react';
import ReactNodeViewPortalsProvider from './utils/ReactNodeViewPortals';
import { Prosemirror } from './Prosemirror';
import { EditorStateContext } from './contexts/EditorStateContext';
import { AuthContext } from './contexts/AuthContext';
import useDebounce from './utils/useDebounce';
import { EditorConfigContext } from './contexts/EditorConfigContext';
import { EditorUIProvider } from './contexts/EditorUIContext';
import { jsx as _jsx } from "react/jsx-runtime";
export let InstanceKey;
export const ProsemirrorEditor = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(AuthContext.Provider, {
  value: props.auth,
  children: /*#__PURE__*/_jsx(Prosemirror, Object.assign({}, props, {
    ref: ref
  }))
}));
const NodeViewWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    editorState,
    setEditorState,
    editorConfig
  } = props;
  const memoizedEditorState = useMemo(() => {
    return {
      editorState,
      setEditorState
    };
  }, [editorState, setEditorState]);
  const debouncedEditorState = useDebounce(memoizedEditorState, 50);
  const debouncedEditorConfig = useDebounce(editorConfig, 50);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: props.auth,
    children: /*#__PURE__*/_jsx(EditorStateContext.Provider, {
      value: debouncedEditorState,
      children: /*#__PURE__*/_jsx(EditorConfigContext.Provider, {
        value: debouncedEditorConfig,
        children: /*#__PURE__*/_jsx(EditorUIProvider, {
          handleFirstClick: props.handleFirstClick,
          children: /*#__PURE__*/_jsx(ReactNodeViewPortalsProvider, {
            children: /*#__PURE__*/_jsx(Prosemirror, Object.assign({}, props, {
              ref: ref
            }))
          })
        })
      })
    })
  });
});
export default NodeViewWrapper;